import { useEffect, useRef, useState } from 'react';
import { useModal } from 'hooks/3catinfo/useModal';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Player from 'components/3catinfo/Player';
import Compartir from 'components/3catinfo/Compartir';
import Icona from 'components/3catinfo/ui/Icona';
import Boto from 'components/3catinfo/Boto';
import __isUndefined from 'lodash/isUndefined';
import clsx from 'clsx';
import styles from './playerreels.module.scss';

const InfoVideo = (props) => {
    const { dataVideo, playerRef, error } = props;
    const { titol, id, sharedReel } = dataVideo;
    const { mutePlayer, setMutePlayer } = useModal();
    const { isMobile, zoomNavigator, isMobileDevice } = useViewport();
    const icona = mutePlayer ? 'ic_novolum' : 'volum';

    const styleInfo = clsx({
        [styles.info]: true,
        [styles.ambZoom]: zoomNavigator > 3
    });

    const styleIconesInfoVideo = clsx({
        [styles.iconesInfoVideo]: true,
        [styles.ambZoom]: zoomNavigator > 2 && !isMobileDevice
    });

    const handleClickMute = async () => {
        setMutePlayer(!mutePlayer);
        playerRef?.current?.mute();
    };

    return (
        <div className={styleInfo} data-testid={`info-video-reel-${id}`}>
            {!error && (
                <div className={styleIconesInfoVideo}>
                    <Boto
                        tag='button'
                        icona={icona}
                        onClick={handleClickMute}
                        isIconaBlanc={true}
                        altIcona='Volum'
                        estil='volumReels'
                        mida={24}
                        className={styles.iconaVolum}
                        isIconaDreta={false}
                    />
                    <Compartir
                        estils='negatiu reels'
                        route={{
                            type: 'web_3catinfo_shared_reel',
                            id,
                            slug: sharedReel.paramsOtherReels,
                            slug2: sharedReel.seccio
                        }}
                        obreEsquerra={isMobile}
                    />
                </div>
            )}
        </div>
    );
};

const ErrorMsg = (props) => {
    const { state, error } = props;
    const msg = state === 'DESP' ? 'Aquest vídeo està despublicat' : 'Hem tingut un error al reproduir el vídeo';
    return (
        error && (
            <div className={styles.errorMsg}>
                <Icona icona='avis' alt='avis' mida={28} isBlanc={true} className={styles.iconaError} />
                <div className={styles.outertext}>{msg}</div>
            </div>
        )
    );
};

const PlayerReels = (props) => {
    const { dataVideo, playVideo, onNextVideo, playerControllerInstance } = props;
    const { id, endPubDate, imatge, state } = dataVideo;
    const { mutePlayer } = useModal();
    const [error, setError] = useState(state === 'DESP');
    const [hideUIPlay, setHideUIPlay] = useState(true);
    const playerRef = useRef();
    const playerStatusRef = useRef({
        playVideo,
        playerReady: false,
        pendingPlay: true
    });
    const timerShowUIPlay = useRef(null);
    const { isMobileDevice, zoomNavigator } = useViewport();
    const stylePlayer = clsx({
        [styles.rmp]: true,
        [styles.isPlaying]: !!playVideo,
        [styles.hideUIPlay]: hideUIPlay
    });

    const styleItemVideo = clsx({
        [styles.itemvideo]: true,
        [styles.ambZoom]: zoomNavigator > 2 && !isMobileDevice
    });

    const handleMouseEnter = () => {
        timerShowUIPlay.current = setTimeout(() => {
            setHideUIPlay(false);
        }, 500);
    };

    const handleMouseLeave = () => {
        timerShowUIPlay.current = setTimeout(() => {
            setHideUIPlay(true);
        }, 200);
    };

    const handleKeyDownDocument = (e) => {
        if (e.key === 'Tab') {
            setHideUIPlay(false);
        }
    };

    const videoActions = () => {
        playerStatusRef.current.pendingPlay = false;
        if (playerStatusRef.current.playVideo) {
            const isMutedVideo = playerRef?.current?.isMuted();
            if (!__isUndefined(isMutedVideo) && mutePlayer !== isMutedVideo) {
                playerRef?.current?.mute();
            }
            playerRef?.current?.continuePlay();
            setHideUIPlay(true);
        } else {
            playerRef?.current?.pause();
            timerShowUIPlay.current = setTimeout(() => {
                setHideUIPlay(true);
            }, 200);
        }
    };

    const playerControllerHandler = (playerController) => {
        playerControllerInstance(playerController);
        playerController.on('ready', () => {
            playerStatusRef.current.playerReady = true;
            if (playerStatusRef.current.pendingPlay) {
                videoActions();
            }
        });
    };

    useEffect(() => {
        playerStatusRef.current.playVideo = playVideo;
        if (!error) {
            if (!playerStatusRef.current.playerReady) {
                playerStatusRef.current.pendingPlay = true;
            } else {
                videoActions();
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playVideo]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDownDocument, true);

        return () => {
            clearTimeout(timerShowUIPlay.current);
            document.removeEventListener('keydown', handleKeyDownDocument);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styleItemVideo} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <div className={styles.contentVideo}>
                <div className={styles.video}>
                    {!error && (
                        <Player
                            key='VoD'
                            ref={playerRef}
                            playerVideoTagId={`player-reel-${id}`}
                            id={id}
                            autoPlay={playVideo}
                            className={stylePlayer}
                            state={state}
                            endPubDate={endPubDate}
                            playerError={setError}
                            imatges={imatge}
                            onNextVideo={onNextVideo}
                            mute={mutePlayer}
                            mostrarBotonsAccessibilitat={false}
                            playerControllerInstance={playerControllerHandler}
                        ></Player>
                    )}
                    <ErrorMsg error={error} state={state} />
                </div>
            </div>
            <InfoVideo dataVideo={dataVideo} playerRef={playerRef} error={error} />
        </div>
    );
};

export default PlayerReels;
